import styled from 'styled-components';

export const ProjectRouterContainer = styled.div`
  a:hover {
    text-decoration: none;
  }
`;
